import { CurrentPlan } from '@aibees/shared/features/current-plan';
import { Card, CardHeader, Typography } from '@mui/material';

export function CurrentPlanView() {
  return (
    <Card variant="outlined" headerDivider>
      <CardHeader
        title={
          <Typography variant="body1" fontWeight={700} color="grey.700">
            Current Plan
          </Typography>
        }
      />

      <CurrentPlan />
    </Card>
  );
}
